import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

export const SmartTextView = ({
  content,
  id,
  TagName,
}) => useMemo(() => (
  <TagName id={id} >
    {content}
  </TagName>), [content, id]);

SmartTextView.propTypes = {
  content: PropTypes.string.isRequired,
  id: PropTypes.string,
  TagName: PropTypes.string,
};

SmartTextView.defaultProps = {
  id: undefined,
  TagName: 'span',
};
